import { createTheme } from '@mui/material/styles';
import typography from './theme/typography';

const theme = createTheme({
  typography,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily:
            '"Inter var", Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: 'rgba(0,0,0,0.23)', // default
        },
        root: {
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: 'red',
            borderWidth: 2,
          },
        },
      },
    },
  },
});

export default theme;